import React from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
} from "@coreui/react";
import DocumentVerificationForm from "./DocumentVerificationForm";
import DocumentVerification from "../../models/document-verification";
import Asset from "../../models/asset";

interface DocumentVerificationUpdateModalProps {
  verification?: DocumentVerification;
  assets: Asset[];
  onClose: () => void;
  onSuccess: () => void;
}

const DocumentVerificationUpdateModal: React.FC<
  DocumentVerificationUpdateModalProps
> = ({ verification, assets, onClose, onSuccess }) => {
  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <CModal show={true} onClose={onClose} size="xl" centered>
      <CModalHeader closeButton>
        <CModalTitle>Editar Verificación de Documentos</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <DocumentVerificationForm
          initialVerification={verification}
          onCancel={onClose}
          onSuccess={handleSuccess}
        />
      </CModalBody>
    </CModal>
  );
};

export default DocumentVerificationUpdateModal;
